import React from 'react';
import styles from './emptySearch.module.sass';
import { Text } from '../../Text';
import { Icon } from '../../Icon';
import { IconSVG } from '../../SpriteSVG';

export const EmptySearch = () => (
  <div>
    <div className={styles.emptySearch}>
      <div className={styles.emptySearchIcon}>
        <Icon
          icon={<IconSVG name={'common/EmptyDate'} width={48} height={48} />}
        />
      </div>
      <div className={styles.emptySearchDescription}>
        <Text variant="heading-8">
          По выбранным параметрам отправлений нет, попробуйте изменить фильтр
          или дату.
        </Text>
      </div>
    </div>
  </div>
);
